<div class="bg-queue">
    <div class="bg-queue__header">
        <h2>Background Queue</h2>
        <button nz-button nzType="primary" (click)="loadQueue()" [nzLoading]="isLoading">
            <nz-icon nzType="reload"></nz-icon>
            Refresh
        </button>
    </div>

    <div *ngIf="isLoading" class="bg-queue__loading">Loading background jobs...</div>

    <nz-table *ngIf="!isLoading" #queueTable [nzData]="jobs" nzBordered [nzFrontPagination]="false">
        <thead>
            <tr>
                <th>Rep</th>
                <th>Company</th>
                <th>Provider</th>
                <th>Background Id</th>
                <th>Status</th>
                <th>Updated</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let job of queueTable.data">
                <td>{{ job?.rep_name || job?.applicant || 'Unknown' | titlecase}}</td>
                <td>{{ job?.company_name || '—' | titlecase}}</td>
                <td>{{ job?.provider_name || '—' | titlecase}}</td>
                <td>{{ job?.background_id || '—' }}</td>
                <td>{{ job?.status || '-' | titlecase}}</td>
                <td>{{ job?.updated_at || job?.updatedAt || '—' | date:'mediumDate'}}</td>
                <td>
                    <a (click)="showEdit(job)">Edit</a>
                </td>
            </tr>
            <tr *ngIf="jobs.length === 0">
                <td colspan="7">Nothing in the queue right now.</td>
            </tr>
        </tbody>
    </nz-table>
</div>

<nz-modal [(nzVisible)]="editOpen" nzTitle="Update Background" nzOkText="Save" (nzOnCancel)="closeEdit()"
    (nzOnOk)="saveEdit()" [nzOkLoading]="selectedJob?._saving">
    <ng-container *nzModalContent>
        <div *ngIf="selectedJob">
            <p><strong>Rep:</strong> {{ selectedJob?.rep_name || selectedJob?.applicant || 'Unknown' | titlecase}}</p>
            <p><strong>Company:</strong> {{ selectedJob?.company_name || '—' | titlecase}}</p>
            <p><strong>Provider:</strong> {{ getProviderName(selectedJob) | titlecase }}</p>
            <p><strong>Status:</strong> {{ selectedJob?.status || 'Pending' | titlecase}}</p>

            <nz-form nzLayout="vertical">
                <nz-form-item>
                    <nz-form-label>Provider</nz-form-label>
                    <nz-form-control>
                        <nz-select [(ngModel)]="selectedJob.provider_id" nzShowSearch nzPlaceHolder="Select provider">
                            <nz-option *ngFor="let provider of providers" [nzLabel]="provider?.name" [nzValue]="provider?.id"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label>Status</nz-form-label>
                    <nz-form-control>
                        <nz-select [(ngModel)]="selectedJob.status" class="bg-queue__status">
                            <nz-option *ngFor="let s of statuses" [nzLabel]="s" [nzValue]="s"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label>Background ID</nz-form-label>
                    <nz-form-control>
                        <input nz-input [(ngModel)]="selectedJob.background_id" placeholder="Enter id" />
                    </nz-form-control>
                </nz-form-item>
            </nz-form>
        </div>
    </ng-container>
</nz-modal>
